import { PdsWidget } from './pds-widget';
import { PolymerMouseEvent } from './interfaces/polymer-mouse-event';
import { LinkItem } from './interfaces/link-item';

interface PdsBannerModel {
  button: LinkItem;
}

export class PdsBanner extends PdsWidget {
  is = 'pds-banner';
  buttons: Array<LinkItem>;
  message: string;
  showControls = false;
  controlsObserver: any;

  attached(): void {
    super.attached();
    // if the controls change, we may need to hide or show the controls div so that the header text is properly justified
    //  https://polymer-library.polymer-project.org/1.0/docs/devguide/local-dom#observe-nodes
    //  observeNodes will call the observer function anytime this.$.control's descendents are added or removed
    this.controlsObserver = this.polymerDom(this.$.controls)
      .observeNodes(() => this.updateShowControls());

    this.updateShowControls();
  }

  detached(): void {
    super.detached();
    // stop watching for changes to the controls - we're detached
    //  https://polymer-library.polymer-project.org/1.0/docs/devguide/local-dom#observe-nodes
    this.polymerDom(this.$.controls).unobserveNodes(this.controlsObserver);
  }

  onButtonClick(event: PolymerMouseEvent<PdsBannerModel>): void {
    // pass the event through to the button callback
    if (event.model.button.callback) {
      event.model.button.callback(event);
    }
  }

  // the button is disabled if the link item isDisabled function returns true
  isDisabled(button: LinkItem): boolean {
    // no context for banner buttons
    return button.disable != null && button.disable.isDisabled({});
  }

  // show the tooltip when the button is disabled and there is non-null non-empty tooltip text
  showTooltip(button: LinkItem): boolean {
    return this.isDisabled(button) && button.disable != null && !!button.disable.disabledTooltip;
  }

  // needed to simplify polymer binding - hide the tooltip when we don't need to show it
  hideTooltip(button: LinkItem): boolean {
    return !this.showTooltip(button);
  }

  // add the tooltip trigger class when we're showing the tooltip
  tooltipTriggerClass(button: LinkItem): string {
    if (this.showTooltip(button)) {
      return 'pds-tooltip-trigger';
    }

    return '';
  }

  // this is used to update the controls area when the light DOM elements change
  updateShowControls(): void {
    // getEffectiveChildren will include the light (i.e. injected) DOM elements - if there are none then the div should be hidden
    //  https://polymer-library.polymer-project.org/1.0/docs/devguide/local-dom#effective-children
    this.showControls = this.getEffectiveChildren('.pds-banner-control').length > 0;
  }
}
